module.exports = {"pt-BR":{"admin":{"components":{"contractField":{"label":"Contrato","notifications":{"fetch":{"failure":"Falha ao buscar contratos"}}}}}}}